import { connect } from 'react-redux'
import CellsPerPositionGraph from './CellsPerPositionGraph'
import { loadImagesForJob } from 'store/jobs'

const mapDispatchToProps = {
  loadImagesForJob
}

const mapStateToProps = (state, ownProps) => {
  const jobId = _.get(ownProps, ['job', 'job_id'])
  let augmentedJob = null
  if (jobId) {
    augmentedJob = state.jobs[jobId]
  }
  return {
    augmentedJob
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CellsPerPositionGraph)



// WEBPACK FOOTER //
// ./src/routes/QC/components/CellsPerPositionGraphContainer.jsx